export default __webpack_public_path__ + "static/media/guidelines-1.73540523.jpeg";